import { Component, OnInit, OnDestroy, Input } from '@angular/core';
import {combineLatest, Subject} from 'rxjs';
import { Pageable, Page, ComponentEvent, StateAwareComponent } from 'src/app/model/rest/base';
import {ManagerColV3RestService} from "../../../services/rest/v3/manager-col-v3-rest.service";
import {filter, finalize, switchMap, tap} from "rxjs/operators";
import * as LessonsV3 from '../../../model/v3/lessons';

export class StudentCreditsComponentEvent extends ComponentEvent {
}

@Component({
    selector: 'app-student-credits',
    templateUrl: './student-credits.component.html',
    styleUrls: ['./student-credits.component.css'],
    standalone: false
})
export class StudentCreditsComponent extends StateAwareComponent<StudentCreditsComponentEvent> implements OnInit, OnDestroy {

  bundles: LessonsV3.LessonBundle[];
  bundleProductCode: string;
  pageQuery: Pageable;
  lastPageResult: Page<LessonsV3.LessonBundle>;
  _lang: string;
  hasNext = false;
  _studentId: number;
  creditsTotal: number;

  studentIdSubject = new Subject<number>();
  schoolIdSubject = new Subject<number>();
  langCodeSubject = new Subject<string>();
  private _schoolId: number;

  ngOnDestroy(): void {
  }

  @Input()
  set schoolId(value: number) {
    this.schoolIdSubject.next(value);
  }

  @Input()
  set studentId(studentId: number) {
    this.studentIdSubject.next(studentId);
  }

  @Input()
  public set langCode(lang: string){
    this.langCodeSubject.next(lang);
  }

  constructor(
    private managerRest: ManagerColV3RestService
  ) {
    super();
    combineLatest(
      this.schoolIdSubject, this.studentIdSubject, this.langCodeSubject
    ).pipe(
      tap<[number, number, string]>(([schoolId, studentId, langCode]) => {
          this._schoolId = schoolId;
          this._studentId = studentId;
          this._lang = langCode;
        }
      ),
      filter<[number, number, string]>(([schoolId, studentId, langCode]) => schoolId != null && studentId != null && langCode != null),
      switchMap(([schoolId, studentId, langCode]) => this.initQuery(schoolId, studentId, langCode))

    ).subscribe();
  }

  get studentId() {
    return this._studentId;
  }

  ngOnInit() {
  }

  private loadAvailableBundles(
    schoolId: number, studentId: number,
    productCode: string, pageable: Pageable) {
    return this.managerRest.findStudentLessonBundles(
      schoolId, studentId, productCode, true, pageable);
  }

  private initQuery(schoolId: number, studentId:number, lang: string) {
    this.eventLoading();
    this.clearQueryData();
    this.bundleProductCode = lang;
    this.pageQuery = Pageable.of(0, 1000, null);
    return this.callAppendQuery(schoolId, studentId);
  }

  callAppendQuery(schoolId: number, studentId: number) {
    this.eventLoading();
    return this.loadAvailableBundles(schoolId, studentId, this.bundleProductCode, this.pageQuery).pipe(
      tap<Page<LessonsV3.LessonBundle>>(result => {
          this.lastPageResult = result;
          this.bundles = this.bundles.concat(result.content);
          this.hasNext = (!result.last);
          this.creditsTotal = 0;
          this.bundles.forEach(bundle => this.creditsTotal += bundle.available);
          this.eventNumberOfElements(result.totalElements);
        }),
      finalize( () => this.eventLoaded())
    )
  }

  loadNext() {
    this.moveNext();
    this.callAppendQuery(this._schoolId, this._studentId).subscribe();
  }

  moveNext() {
    if (!this.hasNext) { return; }
    this.pageQuery = this.pageQuery.next();
  }

  clearQueryData() {
    this.bundles = [];
    this.bundleProductCode = null;
    this.pageQuery = null;
    this.lastPageResult = null;
    this.hasNext = false;
  }



}
